var map = {
	"./de.png": "3282",
	"./es.png": "40c6",
	"./gb.png": "0c04",
	"./it.png": "caef",
	"./pl.png": "d2b5",
	"./ru.png": "d48f",
	"./ua.png": "2a4b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bea2";